import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from '../reducers/selection';
import { makeSelectCabinet } from 'containers/Configurator/selectors/furniture';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { makeSelectLastHistoryCabinet } from 'containers/Configurator/selectors/history';

/**
 * Direct selector to the shelvesSelection state domain
 */

const selectShelvesSelectionDomain = (state: ApplicationRootState) => {
  return state.configurator.selection || initialState;
};

export const makeSelectShelvesLevelSelected = () =>
  createSelector(
    selectShelvesSelectionDomain,
    (substate): number[] => substate.shelvesLevelSelected,
  );

export const makeSelectShelvesSelected = () =>
  createSelector(
    makeSelectCabinet(),
    makeSelectShelvesLevelSelected(),
    (cabinet, levelArray): Shelf[] => {
      if (cabinet) {
        // All is selected if there is no level in level array
        if (levelArray.length === 0) return cabinet.shelves;
        // Filter the selected level from shelves
        return cabinet.shelves.filter(item => levelArray.includes(item.level));
      }
      return [];
    },
  );

export const makeSelectShelvesSelectedLastCabinet = () =>
  createSelector(
    makeSelectLastHistoryCabinet(),
    makeSelectShelvesLevelSelected(),
    (lastCabinet, levelArray): Shelf[] => {
      if (lastCabinet) {
        // All is selected if there is no level in level array
        if (levelArray.length === 0) return lastCabinet.shelves;
        // Filter the selected level from shelves
        return lastCabinet.shelves.filter(item =>
          levelArray.includes(item.level),
        );
      }
      return [];
    },
  );
